export default [
    {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "Profile" */ '@/views/Profile/index.vue')
    },
    {
        path: '/profile/kyc-form',
        name: 'kycForm',
        component: () => import(/* webpackChunkName: "Profile" */ '@/views/Profile/kyc/index.vue')
    },
    {
        path: '/account/config',
        name: 'AccountConfig',
        component: () =>
            import(/* webpackChunkName: "AccountConfig" */ '@/views/AccountConfig/index.vue')
    },
    {
        path: '/account/wallet',
        name: 'Wallet',
        component: () => import(/* webpackChunkName: "Wallet" */ '@/views/Wallet/index.vue')
    },
    {
        path: '/account/myaccount/:uuidAccount',
        name: 'MyAccount',
        component: () => import(/* webpackChunkName: "Wallet" */ '@/views/MyAccount/index.vue')
    },
    {
        path: '/account/operation/:uuidOperation',
        name: 'OperationDetails',
        component: () =>
            import(
                /* webpackChunkName: "Wallet" */ '@/views/Operations/operation-details/index.vue'
            )
    },
    {
        path: '/account/position',
        name: 'Position',
        component: () => import(/* webpackChunkName: "Position" */ '@/views/Position/index.vue'),
        alias: '/'
    },
    {
        path: '/account/operations/:uuidAccount?',
        name: 'Operations',
        component: () => import(/* webpackChunkName: "Operations" */ '@/views/Operations/index.vue')
    },
    /** TODO: estas rutas no son de documentos, sacar a donde corresponda */
    {
        path: '/account/documents',
        name: 'Documents',
        component: () => import(/* webpackChunkName: "Documents" */ '@/views/Documents/index.vue')
    },
    {
        path: '/account/iiff',
        name: 'IIFF',
        component: () => import(/* webpackChunkName: "IIFF" */ '@/views/IIFF/index.vue')
    },
    {
        path: '/account/notifications',
        name: 'Notifications',
        component: () =>
            import(/* webpackChunkName: "Notifications" */ '@/views/Notifications/index.vue')
    },
    {
        path: '/operate',
        name: 'Operar',
        component: () => import(/* webpackChunkName: "Operar" */ '@/views/Operate/index.vue')
    },
    {
        path: '/operate/summary/:uuid',
        name: 'Summary',
        component: () =>
            import(/* webpackChunkName: "Summary" */ '@/views/Operate/operation-summary/index.vue')
    },
    {
        path: '/operate/cancel/:uuid',
        name: 'Cancel',
        component: () =>
            import(/* webpackChunkName: "Cancel" */ '@/views/Operate/operation-cancel/index.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "Contact" */ '@/views/Contact/index.vue')
    }
];
